module.exports = __webpack_public_path__ + "img/mlflyzng.36d03797.jpg";